module.exports = __webpack_public_path__ + "static/media/main-image.252d0647.jpg";